import React, { FC } from 'react';
import styles from './index.module.scss';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe } from '@fortawesome/pro-light-svg-icons';
import { Skeleton } from 'src/common';

interface IProps {
  loading: boolean;
  label: string;
}

export const EmailDomainPanel: FC<IProps> = props => {
  const { loading, label } = props;
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <Skeleton loading={loading} active={loading} className={styles.loading} paragraph={false} />

      {!loading && (
        <div className={styles.content}>
          <FontAwesomeIcon icon={faGlobe} className={styles.icon} />
          <span>{t('Security.ssoDomain')} </span>
          <span>{label}</span>
        </div>
      )}
    </div>
  );
};

export default EmailDomainPanel;
